var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Form',{attrs:{"associate":_vm.associate},on:{"saveModel":function($event){return _vm.$router.push('/admin/associates')}}})}
var staticRenderFns = []

export { render, staticRenderFns }